export default "__VITE_ASSET__a9e324ad__"